export type { CardProps } from './Card';
export { default } from './Card';
